<template>
  <component :is="type" v-bind="props"><slot /></component>
</template>

<script>
const IS_EXTERNAL_URL = /^(http:\/\/|https:\/\/|mailto:)/

export default {
  name: 'ShLink',

  props: {
    to: {
      type: String || Object,
      default: ''
    },
    target: {
      type: String,
      default: ''
    },
    prefetch: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    props () {
      if (this.type === 'a') {
        return {
          href: this.to,
          target: this.target
        }
      }

      return {
        to: this.to,
        target: this.target,
        prefetch: this.prefetch
      }
    },

    type () {
      if (IS_EXTERNAL_URL.test(this.to)) {
        return 'a'
      }

      return 'nuxt-link'
    }
  }
}
</script>
